import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ErrorToast, SuccessToast } from "../helper/FormHelper";
import LoadingButton from "./LoadingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faLinkedin,
  faWhatsapp,
  faTwitter,
  faYoutube,
  faWeixin,
} from "@fortawesome/free-brands-svg-icons";

export default function GetAdmissionForm() {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    course: "",
    transaction: "",
  });

  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const courses = [
    "Accounting Certificate Courses",
    "Professional Taxation Training",
    "Professional Management Training",
    "Professional Business Courses",
  ];

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    const { username, email, phone, course, transaction } = formData;

    if (!username) return ErrorToast("Name is Required");
    if (!email) return ErrorToast("Email is Required");
    if (!phone) return ErrorToast("Phone Number is Required");
    if (!course) return ErrorToast("Course Selection is Required");
    if (!transaction) return ErrorToast("Transaction ID / Bkash Number is Required");

    setLoading(true);

    try {
      const response = await fetch("https://formsubmit.co/ajax/jkassociatesbd@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Name: username,
          Email: email,
          Phone: phone,
          Course: course,
          Transaction: transaction,
          _subject: "New Admission Form Submission",
        }),
      });

      if (response.ok) {
        setSuccessMsg("🎉 Your form has been submitted successfully!");
        SuccessToast("Form Submitted Successfully!");
        setFormData({
          username: "",
          email: "",
          phone: "",
          course: "",
          transaction: "",
        });
      } else {
        ErrorToast("Submission failed, please try again!");
      }
    } catch (error) {
      ErrorToast("Something went wrong. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div
        className="d-flex flex-column flex-md-row"
        style={{
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        {/* LEFT SIDE INFO */}
        <div
          style={{
            flex: 1,
            background: "#0A4FA3",
            color: "white",
            padding: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: isMobile ? "center" : "left",
            justifyContent: "center",
          }}
        >
          <h2 style={{ marginBottom: "18px", color: "#FFF" }}>
            Campus Information
          </h2>

          <p>
            <strong>📍 Address:</strong>
            <br />
            752/2, Begum Rokeya Ave, Shewrapara, Dhaka 1216, Bangladesh
          </p>
          <p>
            <strong>📞 Phone:</strong>
            <br />
            +8801601-404971 (Call for training)
            <br />
            +8801511-404971
          </p>
          <p>
            <strong>✉️ Email:</strong>
            <br />
            info@jkassociates.com.bd
          </p>
          <p>
            <strong>💬 WeChat:</strong>
            <br />
            WeChat ID: jkassociates{" "}
            <FontAwesomeIcon icon={faWeixin} style={{ marginLeft: "8px" }} />
          </p>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              gap: "20px",
              fontSize: "24px",
              justifyContent: isMobile ? "center" : "flex-start",
              flexWrap: "wrap",
            }}
          >
            <a
              href="https://jkassociates.com.bd"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#FFFF" }}
            >
              <FontAwesomeIcon icon={faGlobe} />
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=01601404971&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#25D366" }}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a
              href="https://twitter.com/jkassociates"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1DA1F2" }}
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a
              href="https://facebook.com/jkassociates"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#FFF" }}
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              href="https://linkedin.com/jkassociates"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#FFF" }}
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href="https://youtube.com/jkassociates"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#FF0000" }}
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div
          style={{
            flex: 1,
            padding: "30px",
            backgroundColor: "#e7f1ff",
          }}
        >
          <h3
            style={{
              color: "#0d6efd",
              textAlign: "center",
              marginBottom: "25px",
              fontWeight: "bold",
            }}
          >
            Get Admission
          </h3>

          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div className="mb-3">
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Enter your name"
                className="form-control"
                style={{ borderRadius: "8px", padding: "12px" }}
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="form-control"
                style={{ borderRadius: "8px", padding: "12px" }}
              />
            </div>

            {/* Phone */}
            <div className="mb-3">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                className="form-control"
                style={{ borderRadius: "8px", padding: "12px" }}
              />
            </div>

            {/* Course */}
            <div className="mb-3">
              <select
                name="course"
                value={formData.course}
                onChange={handleChange}
                className="form-select"
                style={{
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#fff",
                }}
              >
                <option value="" disabled>
                  -- Select a course --
                </option>
                {courses.map((c, i) => (
                  <option key={i}>{c}</option>
                ))}
              </select>
            </div>

            {/* Transaction / Bkash */}
            <div className="mb-3">
              <input
                type="text"
                name="transaction"
                value={formData.transaction}
                onChange={handleChange}
                placeholder="Transaction ID / Bkash Number"
                className="form-control"
                style={{ borderRadius: "8px", padding: "12px" }}
              />
            </div>

            {/* Submit Button */}
            {loading ? (
              <button
                disabled
                style={{
                  width: "100%",
                  padding: "12px",
                  background: "#0A4FA3",
                  color: "#fff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                Loading <LoadingButton style={{ width: "18px", height: "18px" }} />
              </button>
            ) : (
              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "12px",
                  backgroundColor: "#0d6efd",
                  color: "#fff",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
              >
                Submit
              </button>
            )}
          </form>

          {/* ✅ Custom Success Message */}
          {successMsg && (
            <div
              style={{
                marginTop: "20px",
                backgroundColor: "#d1e7dd",
                color: "#0f5132",
                border: "1px solid #badbcc",
                borderRadius: "8px",
                padding: "12px",
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              {successMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
